import {Box, Button, HStack, Input, Text, VStack} from "@chakra-ui/react";
import dayjs from "dayjs";
import {useMemo, useState} from "react";

const WhatsUpBubble = ({message, onYes, onNo, chat}) => {
    const [showInput, setShowInput] = useState(false);
    const [phone, setPhone] = useState('');
    const [actionsVisible, setActionsVisible] = useState(true);

    const messageContent = useMemo(() => {
        return message.text.replace('{%WhatsApp_Start}', '');
    }, [message.text]);

    const hideInput = () => {
        setShowInput(false);
        setActionsVisible(false);
    }

    const handleOnYes = () => {
        onYes(phone, hideInput)
    }

    return (
        <HStack w={'full'} alignItems={'flex-end'} justifyContent={'flex-end'} flexDirection={'row-reverse'} py={1}>
            <Text fontSize={11} color={'text.chatDate'}>{dayjs(new Date(message.timestamp)).format('HH:mm')}</Text>
            <Box maxW={'57%'} bg={'bg.chatBot'} borderRadius={12} borderBottomLeftRadius={0} px={4} pt={3} pb={3}>
                <Text fontSize={15} whiteSpace="pre-wrap" color={'white'} mb={3}>{messageContent}</Text>
                {actionsVisible &&
                    <>
                        {!showInput ? (
                            <HStack gap={2}>
                                <Button size="sm" colorScheme="green" onClick={() => setShowInput(true)}>Yes</Button>
                                <Button size="sm" colorScheme="red" onClick={onNo}>No</Button>
                            </HStack>
                        ) : (
                            <VStack gap={2} alignItems="stretch">
                                <Input
                                    size="sm"
                                    placeholder="Enter your phone number"
                                    value={phone}
                                    onChange={e => setPhone(e.target.value)}
                                    bg="white"
                                    color="black"
                                />
                                <HStack gap={2}>
                                    <Button size="sm" colorScheme="green" onClick={handleOnYes}>Ok</Button>
                                    <Button size="sm" colorScheme="red" onClick={() => {
                                        setShowInput(false);
                                        setPhone('');
                                    }}>Cancel</Button>
                                </HStack>
                            </VStack>
                        )}
                    </>

                }
            </Box>
        </HStack>
    );
};

export default WhatsUpBubble;
